import { render, staticRenderFns } from "./BarSelectionPreview.vue?vue&type=template&id=6f22a35e&scoped=true"
import script from "./BarSelectionPreview.vue?vue&type=script&lang=js"
export * from "./BarSelectionPreview.vue?vue&type=script&lang=js"
import style0 from "./BarSelectionPreview.vue?vue&type=style&index=0&id=6f22a35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f22a35e",
  null
  
)

export default component.exports